<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>تنظیمات درگاه</h4>
          </div>
          <div class="widget-body">
            <form id="licenseForm" class="form-horizontal">
              <!-- license name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">پرداخت</label>
                <div class="col-lg-6">
                  <select name="" v-model="setting.status" class="form-control" id="">
                    <option value="ipDeactive">تمامی پرداخت ها از درگاه پرداخت داخلی</option>
                    <option value="ipActive"
                      >پرداخت های ip خارجی از سرویس دهنده خارجی و داخلی از درگاه پرداخت داخلی</option
                    >
                    <option value="deactive">غیر فعال کردن تمامی پرداخت ها</option>
                    <option value="justIran">فعال برای کاربر با ip داخلی و غیر فعال برای خارجی</option>
                  </select>
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">              
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">پیام فارسی</label>
                  <div class="col-lg-6">
                  <input class="form-control" type="text" name="" id="" v-model="setting.message.fa">
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">                
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">پیام انگلیسی</label>
                <div class="col-lg-6">
                  <input class="form-control" type="text" name="" id="" v-model="setting.message.en">
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/licenses">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import purchaseSettingService from '../../../../services/finantial';
export default {
  name: 'purchaseSetting',
  data() {
    return {
      setting: {},
    };
  },
  created() {
    this.getSetting();
  },
  methods: {
    async getSetting() {
      try {
        const setting = await purchaseSettingService.getSetting();
        this.setting = setting;
        console.log(setting);
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      try {
        await purchaseSettingService.setSetting(this.setting);
        this.getSetting();
        window.notif({ isError: false, mssg: 'اپدیت شد' });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
